import { Component, type ErrorInfo, type ReactNode } from 'react';

interface State {
  error: Error | null;
}

/**
 * Заслон от падения интерфейса.
 *
 * Без него любая ошибка в рендере оставляет пользователя перед белым экраном
 * без единой подсказки — а в Telegram ещё и без консоли, чтобы понять причину.
 * Здесь он хотя бы видит текст ошибки и может перезагрузить приложение.
 */
export default class ErrorBoundary extends Component<
  { children: ReactNode },
  State
> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    // Отправлять некуда — сбора ошибок пока нет. В консоли след останется.
    console.error('Сбой интерфейса:', error, info.componentStack);
  }

  render() {
    if (!this.state.error) return this.props.children;

    return (
      <div className="container" style={{ paddingTop: 32 }}>
        <div className="card">
          <h3>Что-то сломалось</h3>
          <div className="meta" style={{ marginBottom: 12 }}>
            Приложение не смогло отрисовать этот экран. Перезагрузите — если
            повторится, пришлите этот текст в поддержку.
          </div>
          <div className="error" style={{ marginBottom: 12 }}>
            {this.state.error.message}
          </div>
          <button onClick={() => window.location.reload()}>Перезагрузить</button>
        </div>
      </div>
    );
  }
}
